<template>  
  <v-container>
    <v-row>
      <v-col xs="12">
        <v-card class="elevation-5">
          <v-card-title>
            Relatórios
          </v-card-title>

          <template 
            v-if = "this.$store.state.user.id === 4 || this.$store.state.user.id === 297 || this.$store.state.user.id === 232 || this.$store.state.user.id === 341 || this.$store.state.user.id === 344 || this.$store.state.user.id === 191 || this.$store.state.user.id === 89 || this.$store.state.user.id === 3 || this.$store.state.user.id === 276 || this.$store.state.user.id === 279 || this.$store.state.user.id > 165"
          >
            <span>Uma nova aba será aberta em instantes ...</span>
          </template>
          <template v-else>
            <span>O relatório temporariamente indisponivel.</span>
            <!-- <v-container fluid grid-list-xl>
              <Filters @updateReport="updateReport" />
            </v-container> -->
          </template>

        </v-card>

      </v-col>
    </v-row>

    <v-row v-if="$store.state.user_store_report" >
      <v-col xs="12">
        <v-card class="elevation-5">
          <v-container fluid grid-list-xl>
            <Report :key="report" />
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import Report from './Report';
import Filters from './Filters';

export default {
  name: 'Index',
  components:{
    Report,
    Filters
  },
  methods: {
    updateReport() {
      this.report++;
    }
  },
  computed: {},
  watch: {},
  created() {
    if(this.$store.state.user.id === 4 || this.$store.state.user.id === 297 || this.$store.state.user.id === 232 || this.$store.state.user.id === 341 || this.$store.state.user.id === 344 || this.$store.state.user.id === 191 || this.$store.state.user.id === 89 || this.$store.state.user.id === 3 || this.$store.state.user.id === 276 || this.$store.state.user.id === 279 || this.$store.state.user.id > 165){
      window.open('http://beta.manyconvert.com/', '_blank');
    }
    // this.$store.dispatch('fetchAttendantsReport');
  },
  data () {
    return {
      report: 0,
    };
  }
}
</script>

<style lang="css" scoped>
</style>